import { databaseDataFragment, databaseVersionFragment } from '#fragments/database.js';
import { databaseObjectFragment, databaseObjectVersionFragment } from '#fragments/databaseObject';
import { ruledPriceFragment, ruledPriceVersionFragment } from '#fragments/ruledPrices';
import { subcontractingFragment, subcontractingVersionFragment } from '#fragments/subcontracting';
import { gql } from '@apollo/client/core';

export const moduleSelectLinkDataFragment = gql`
  fragment ModuleSelectLinkDataFragment on module_select_links {
    id
    module_id
    name
    description
    is_deleted_at_version
    order
    include_delete_option
    data
    _created_at
    _created_by
    _updated_at
    _updated_by
  }
`;

export const moduleSelectLinkModuleOptionFragment = gql`
  fragment ModuleSelectLinkModuleOptionFragment on module_select_link_module_options {
    id
    module_select_link_id
    module_id
    order
    data
    _created_at
    _created_by
    _updated_at
    _updated_by
  }
`;

export const moduleSelectLinkDatabaseObjectOptionFragment = gql`
  fragment ModuleSelectLinkDatabaseObjectOptionFragment on module_select_link_database_objects_options {
    id
    module_select_link_id
    database_object_id
    order
    data
    _created_at
    _created_by
    _updated_at
    _updated_by
  }
`;

export const moduleSelectLinkDatabaseObjectOptionWithObjectFragment = gql`
  ${moduleSelectLinkDatabaseObjectOptionFragment}
  ${databaseObjectFragment}
  ${databaseObjectVersionFragment}
  ${databaseVersionFragment}
  ${databaseDataFragment}
  fragment ModuleSelectLinkDatabaseObjectOptionWithObjectFragment on module_select_link_database_objects_options {
    ...ModuleSelectLinkDatabaseObjectOptionFragment
    database_object {
      ...DatabaseObjectFragment
      latest_database_object_version(where: { is_latest: { _eq: true } }) {
        ...DatabaseObjectVersionFragment
      }
      database {
      ...DatabaseDataFragment
      latest_database_version(where: { is_latest: { _eq: true } }) {
        ...DatabaseVersionFragment
      }
    }
    }
  }
`;

export const moduleSelectLinkRuledPriceOptionFragment = gql`
  fragment ModuleSelectLinkRuledPriceOptionFragment on module_select_link_ruled_price_options {
    id
    module_select_link_id
    ruled_price_id
    order
    data
    _created_at
    _created_by
    _updated_at
    _updated_by
  }
`;

export const moduleSelectLinkRuledPriceOptionWithPriceFragment = gql`
  ${moduleSelectLinkRuledPriceOptionFragment}
  ${ruledPriceFragment}
  ${ruledPriceVersionFragment}
  fragment ModuleSelectLinkRuledPriceOptionWithPriceFragment on module_select_link_ruled_price_options {
    ...ModuleSelectLinkRuledPriceOptionFragment
    ruled_price {
      ...RuledPriceFragment
      ruled_price_versions(where: { is_latest: { _eq: true } }) {
        ...RuledPriceVersionFragment
      }
    }
  }
`;

export const moduleSelectLinkSubcontractingOptionFragment = gql`
  fragment ModuleSelectLinkSubcontractingOptionFragment on module_select_link_subcontracting_options {
    id
    module_select_link_id
    subcontracting_id
    order
    data
    _created_at
    _created_by
    _updated_at
    _updated_by
  }
`;

export const moduleSelectLinkSubcontractingOptionWithSubcontractingFragment = gql`
  ${moduleSelectLinkSubcontractingOptionFragment}
  ${subcontractingFragment}
  ${subcontractingVersionFragment}
  fragment ModuleSelectLinkSubcontractingOptionWithSubcontractingFragment on module_select_link_subcontracting_options {
    ...ModuleSelectLinkSubcontractingOptionFragment
    subcontracting {
      ...SubcontractingFragment
      subcontracting_version(where: { is_latest: { _eq: true } }) {
        ...SubcontractingVersionFragment
      }
    }
  }
`;

export const moduleSelectLinkFragment = gql`
  ${moduleSelectLinkDataFragment}
  ${moduleSelectLinkModuleOptionFragment}
  ${moduleSelectLinkDatabaseObjectOptionFragment}
  ${moduleSelectLinkRuledPriceOptionFragment}
  ${moduleSelectLinkSubcontractingOptionFragment}
  fragment ModuleSelectLinkFragment on module_select_links {
    ...ModuleSelectLinkDataFragment
    module_select_link_module_options {
      ...ModuleSelectLinkModuleOptionFragment
    }
    module_select_link_database_objects_options {
      ...ModuleSelectLinkDatabaseObjectOptionFragment
    }
    module_select_link_ruled_price_options {
      ...ModuleSelectLinkRuledPriceOptionFragment
    }
    module_select_link_subcontracting_options {
      ...ModuleSelectLinkSubcontractingOptionFragment
    }
  }
`;
